import { createI18n } from 'vue-i18n'
import esLocale from './locale/es'
import enLocale from './locale/en'
import itLocale from './locale/it'
import ptLocale from './locale/pt'

const dateTimeFormats = {
  es: {
    long: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    },
    hour: {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    }
  },
  en: {
    long: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    },
    hour: {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    }
  },
  pt: {
    long: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    },
    hour: {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    }
  },
  it: {
    long: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    },
    hour: {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    }
  }
}

const numberFormats = {
  es: {
    decimal: {
      style: 'decimal',
      useGrouping: false,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    max_decimal: {
      style: 'decimal',
      useGrouping: false,
      minimumFractionDigits: 0,
      maximumFractionDigits: 6
    },
    two_to_six_decimal: {
      style: 'decimal',
      useGrouping: false,
      minimumFractionDigits: 2,
      maximumFractionDigits: 6
    },
    table_two_to_six_decimal: {
      style: 'decimal',
      useGrouping: true,
      minimumFractionDigits: 2,
      maximumFractionDigits: 6
    },
    three_decimal: {
      style: 'decimal',
      useGrouping: false,
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    },
    table_three_decimal: {
      style: 'decimal',
      useGrouping: true,
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    },
    table: {
      style: 'decimal',
      useGrouping: true,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  },
  en: {
    decimal: {
      style: 'decimal',
      useGrouping: false,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    max_decimal: {
      style: 'decimal',
      useGrouping: false,
      minimumFractionDigits: 0,
      maximumFractionDigits: 6
    },
    two_to_six_decimal: {
      style: 'decimal',
      useGrouping: false,
      minimumFractionDigits: 2,
      maximumFractionDigits: 6
    },
    table_two_to_six_decimal: {
      style: 'decimal',
      useGrouping: true,
      minimumFractionDigits: 2,
      maximumFractionDigits: 6
    },
    three_decimal: {
      style: 'decimal',
      useGrouping: false,
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    },
    table_three_decimal: {
      style: 'decimal',
      useGrouping: true,
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    },
    table: {
      style: 'decimal',
      useGrouping: true,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  },
  pt: {
    decimal: {
      style: 'decimal',
      useGrouping: false,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    max_decimal: {
      style: 'decimal',
      useGrouping: false,
      minimumFractionDigits: 0,
      maximumFractionDigits: 6
    },
    two_to_six_decimal: {
      style: 'decimal',
      useGrouping: false,
      minimumFractionDigits: 2,
      maximumFractionDigits: 6
    },
    table_two_to_six_decimal: {
      style: 'decimal',
      useGrouping: true,
      minimumFractionDigits: 2,
      maximumFractionDigits: 6
    },
    three_decimal: {
      style: 'decimal',
      useGrouping: false,
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    },
    table_three_decimal: {
      style: 'decimal',
      useGrouping: true,
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    },
    table: {
      style: 'decimal',
      useGrouping: true,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  },
  it: {
    decimal: {
      style: 'decimal',
      useGrouping: false,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    max_decimal: {
      style: 'decimal',
      useGrouping: false,
      minimumFractionDigits: 0,
      maximumFractionDigits: 6
    },
    two_to_six_decimal: {
      style: 'decimal',
      useGrouping: false,
      minimumFractionDigits: 2,
      maximumFractionDigits: 6
    },
    table_two_to_six_decimal: {
      style: 'decimal',
      useGrouping: true,
      minimumFractionDigits: 2,
      maximumFractionDigits: 6
    },
    three_decimal: {
      style: 'decimal',
      useGrouping: false,
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    },
    table_three_decimal: {
      style: 'decimal',
      useGrouping: true,
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    },
    table: {
      style: 'decimal',
      useGrouping: true,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  }
}


const messages = {
  es: esLocale,
  en: enLocale,
  it: itLocale,
  pt: ptLocale
}

const i18n = createI18n({
  //legacy: false, // para usar la Composition API
  globalInjection: true,  
  locale: 'es', // Idioma predeterminado
  messages,
  dateTimeFormats,
  numberFormats
})

// OnesaitLocale.i18n((key, value) => i18n.t(key, value))

export default i18n